export default "__VITE_ASSET__c7fe8ae3__"